import {Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ExpressionModel} from "web-shared";
import {
  ExpressionFormulaEditorComponent
} from "web-shared";
import {BaseComponent, EditableComponent, LeModalService} from "common-shared";
import {map, takeUntil} from "rxjs/operators";
import {AceConfigInterface} from "ngx-ace-wrapper";
import {skip, Subject, Subscription} from "rxjs";

@Component({
  selector: '[app-expression-formula-cell]',
  templateUrl: './expression-formula-cell.component.html',
  styles: []
})
export class ExpressionFormulaCellComponent extends BaseComponent implements OnInit {
  @Input() expression: ExpressionModel;
  @Input() placeholder: string;
  @Input() readonly: boolean = false;
  @Output() changed = new EventEmitter<ExpressionModel>();
  public config: AceConfigInterface = {
    mode: 'javascript',
    theme: 'xcode',
    readOnly: false,
    showLineNumbers: false,
    showGutter: false,
    showPrintMargin: false,
    cursorStyle: 'wide',
    enableBasicAutocompletion: true,
    fontSize: 15,
    highlightActiveLine: false,
    highlightSelectedWord: false,
    wrap: true,
    maxLines: Infinity,
  };
  isModalOpen = false;
  onChanged$ = new Subject<void>();
  onExternalChanged$ = new Subject<void>();
  onChangedSubscription : Subscription;
  @ViewChild(EditableComponent) editableComponent: EditableComponent;

  constructor(private leModalService: LeModalService) {
    super();
  }

  ngOnInit(): void {
    this.config["indentedSoftWrap"] = false;
  }

  listenValueChange() {
    this.onChangedSubscription = this.onChanged$.pipe(skip(this.expression?.Formula ? 1 : 0), takeUntil(this.componentDestroyed), map(() => this.changed.emit(this.expression))).subscribe();
    this.onChangedSubscription.add(this.onExternalChanged$.pipe(skip(this.expression?.ExternalFormula ?1 : 0), takeUntil(this.componentDestroyed), map(() => this.changed.emit(this.expression))).subscribe());
  }

  edit() {
    this.isModalOpen = true;
    this.leModalService.show(ExpressionFormulaEditorComponent, {class: 'modal-lg', initialState: {expression: this.expression, hasExternalFormula: true}})
      .onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.changed.emit(this.expression)
      this.isModalOpen = false;
    });
  }

  @HostListener('keydown.arrowdown', ['$event'])
  @HostListener('keydown.arrowup', ['$event'])
  @HostListener('keydown.arrowleft', ['$event'])
  @HostListener('keydown.arrowright', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  onArrowKeyDown(event: KeyboardEvent) {
    event.stopPropagation();
  }

  onModeChanged(event: 'edit' | 'view') {
    if (event === 'edit') {
      this.listenValueChange();
    } else {
      this.onChangedSubscription.unsubscribe();
    }
  }

  @HostListener('mousedown')
  onMouseDown() {
    this.editableComponent.displayEditMode();
  }
}
